// Both queues use the same ordering and tie breakers, with type-specific fields.
export const createProcessingComparator = (mode, fields) => (a, b) => {
  const byPaDesc = fields.pa(b) - fields.pa(a);
  const byCreatedDesc = fields.created(b) - fields.created(a);
  const fallback = byPaDesc || byCreatedDesc || String(b.id || '').localeCompare(String(a.id || ''));
  switch (mode) {
    case 'paAsc':
      return -byPaDesc || -byCreatedDesc || fallback;
    case 'selectionDesc':
      return fields.selection(b) - fields.selection(a) || fallback;
    case 'selectionAsc':
      return fields.selection(a) - fields.selection(b) || -byPaDesc || -byCreatedDesc || fallback;
    case 'createdDesc':
      return byCreatedDesc || fallback;
    case 'createdAsc':
      return -byCreatedDesc || -byPaDesc || fallback;
    case 'deadlineAsc':
      return (fields.deadline(a) || Number.MAX_SAFE_INTEGER) -
        (fields.deadline(b) || Number.MAX_SAFE_INTEGER) || fallback;
    case 'deadlineDesc':
      return fields.deadline(b) - fields.deadline(a) || fallback;
    case 'status':
      return fields.status(a).localeCompare(fields.status(b), 'zh-Hant') || fallback;
    default:
      return fallback;
  }
};

// Groups retain their internal sorted order and type-specific actions. Their
// first item determines placement, matching the existing grouping semantics.
export const mergeProcessingGroups = (exchanges, forms, mode, valuesOf) => {
  const groups = [
    ...exchanges.map(group => ({ ...group, kind: 'exchange' })),
    ...forms.map(group => ({ ...group, kind: 'form' })),
  ].map(group => ({ ...group, sortValues: valuesOf(group, group.kind) }));
  const compare = createProcessingComparator(mode, {
    pa: value => value.pa,
    created: value => value.created,
    selection: value => value.selection,
    deadline: value => value.deadline,
    status: value => value.status,
  });
  return groups.sort((a, b) => compare(a.sortValues, b.sortValues) || a.key.localeCompare(b.key));
};
